export default "__VITE_ASSET__hfT1Ihbi__"